module.exports = {
lines:[
    {
        chunks: {
            line_0_begin: {
                x: 9,
                y: 296
            },
            line_0_cell_0: {
                x: 32,
                y: 296
            },
            line_0_cell_1: {
                x: 224,
                y: 296
            },
            line_0_cell_2: {
                x: 416,
                y: 296
            },
            line_0_cell_3: {
                x: 608,
                y: 296
            },
            line_0_cell_4: {
                x: 800,
                y: 296
            },
            line_0_gap_0: {
                x: 223,
                y: 296
            },
            line_0_gap_1: {
                x: 415,
                y: 296
            },
            line_0_gap_2: {
                x: 607,
                y: 296
            },
            line_0_gap_3: {
                x: 799,
                y: 296
            }
        },
        trajectory: [
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_1_begin: {
                x: 9,
                y: 105
            },
            line_1_cell_0: {
                x: 32,
                y: 105
            },
            line_1_cell_1: {
                x: 224,
                y: 105
            },
            line_1_cell_2: {
                x: 416,
                y: 105
            },
            line_1_cell_3: {
                x: 608,
                y: 105
            },
            line_1_cell_4: {
                x: 800,
                y: 105
            },
            line_1_gap_0: {
                x: 223,
                y: 105
            },
            line_1_gap_1: {
                x: 415,
                y: 105
            },
            line_1_gap_2: {
                x: 607,
                y: 105
            },
            line_1_gap_3: {
                x: 799,
                y: 105
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_2_begin: {
                x: 9,
                y: 486
            },
            line_2_cell_0: {
                x: 32,
                y: 486
            },
            line_2_cell_1: {
                x: 224,
                y: 486
            },
            line_2_cell_2: {
                x: 416,
                y: 486
            },
            line_2_cell_3: {
                x: 608,
                y: 486
            },
            line_2_cell_4: {
                x: 800,
                y: 486
            },
            line_2_gap_0: {
                x: 223,
                y: 486
            },
            line_2_gap_1: {
                x: 415,
                y: 486
            },
            line_2_gap_2: {
                x: 607,
                y: 486
            },
            line_2_gap_3: {
                x: 799,
                y: 486
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_3_begin: {
                x: 9,
                y: 86
            },
            line_3_cell_0: {
                x: 32,
                y: 86
            },
            line_3_cell_1: {
                x: 260,
                y: 224
            },
            line_3_cell_2: {
                x: 422,
                y: 414
            },
            line_3_cell_3: {
                x: 608,
                y: 224
            },
            line_3_cell_4: {
                x: 800,
                y: 116
            },
            line_3_gap_0: {
                x: 223,
                y: 173
            },
            line_3_gap_1: {
                x: 415,
                y: 399
            },
            line_3_gap_2: {
                x: 603,
                y: 409
            },
            line_3_gap_3: {
                x: 777,
                y: 200
            }
        },
        trajectory: [
            0,
            1,
            2,
            1,
            0
        ]
    },
    {
        chunks: {
            line_4_begin: {
                x: 9,
                y: 505
            },
            line_4_cell_0: {
                x: 32,
                y: 414
            },
            line_4_cell_1: {
                x: 224,
                y: 224
            },
            line_4_cell_2: {
                x: 416,
                y: 75
            },
            line_4_cell_3: {
                x: 642,
                y: 224
            },
            line_4_cell_4: {
                x: 816,
                y: 414
            },
            line_4_gap_0: {
                x: 222,
                y: 412
            },
            line_4_gap_1: {
                x: 384,
                y: 188
            },
            line_4_gap_2: {
                x: 607,
                y: 179
            },
            line_4_gap_3: {
                x: 799,
                y: 389
            }
        },
        trajectory: [
            2,
            1,
            0,
            1,
            2
        ]
    },
    {
        chunks: {
            line_5_begin: {
                x: 9,
                y: 145
            },
            line_5_cell_0: {
                x: 32,
                y: 145
            },
            line_5_cell_1: {
                x: 224,
                y: 145
            },
            line_5_cell_2: {
                x: 440,
                y: 224
            },
            line_5_cell_3: {
                x: 616,
                y: 414
            },
            line_5_cell_4: {
                x: 800,
                y: 445
            },
            line_5_gap_0: {
                x: 223,
                y: 145
            },
            line_5_gap_1: {
                x: 415,
                y: 191
            },
            line_5_gap_2: {
                x: 607,
                y: 397
            },
            line_5_gap_3: {
                x: 799,
                y: 445
            }
        },
        trajectory: [
            0,
            0,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_6_begin: {
                x: 9,
                y: 435
            },
            line_6_cell_0: {
                x: 32,
                y: 435
            },
            line_6_cell_1: {
                x: 224,
                y: 414
            },
            line_6_cell_2: {
                x: 416,
                y: 224
            },
            line_6_cell_3: {
                x: 608,
                y: 145
            },
            line_6_cell_4: {
                x: 800,
                y: 145
            },
            line_6_gap_0: {
                x: 223,
                y: 435
            },
            line_6_gap_1: {
                x: 392,
                y: 390
            },
            line_6_gap_2: {
                x: 574,
                y: 190
            },
            line_6_gap_3: {
                x: 799,
                y: 145
            }
        },
        trajectory: [
            2,
            2,
            1,
            0,
            0
        ]
    },
    {
        chunks: {
            line_7_begin: {
                x: 9,
                y: 345
            },
            line_7_cell_0: {
                x: 32,
                y: 233
            },
            line_7_cell_1: {
                x: 229,
                y: 101
            },
            line_7_cell_2: {
                x: 455,
                y: 224
            },
            line_7_cell_3: {
                x: 633,
                y: 414
            },
            line_7_cell_4: {
                x: 800,
                y: 366
            },
            line_7_gap_0: {
                x: 223,
                y: 225
            },
            line_7_gap_1: {
                x: 415,
                y: 175
            },
            line_7_gap_2: {
                x: 607,
                y: 379
            },
            line_7_gap_3: {
                x: 786,
                y: 401
            }
        },
        trajectory: [
            1,
            0,
            1,
            2,
            1
        ]
    },
    {
        chunks: {
            line_8_begin: {
                x: 9,
                y: 246
            },
            line_8_cell_0: {
                x: 32,
                y: 246
            },
            line_8_cell_1: {
                x: 269,
                y: 414
            },
            line_8_cell_2: {
                x: 416,
                y: 224
            },
            line_8_cell_3: {
                x: 608,
                y: 101
            },
            line_8_cell_4: {
                x: 830,
                y: 224
            },
            line_8_gap_0: {
                x: 223,
                y: 357
            },
            line_8_gap_1: {
                x: 415,
                y: 414
            },
            line_8_gap_2: {
                x: 594,
                y: 210
            },
            line_8_gap_3: {
                x: 799,
                y: 188
            }
        },
        trajectory: [
            1,
            2,
            1,
            0,
            1
        ]
    },
    {
        chunks: {
            line_9_begin: {
                x: 31,
                y: 112
            },
            line_9_cell_0: {
                x: 32,
                y: 112
            },
            line_9_cell_1: {
                x: 289,
                y: 224
            },
            line_9_cell_2: {
                x: 416,
                y: 100
            },
            line_9_cell_3: {
                x: 624,
                y: 224
            },
            line_9_cell_4: {
                x: 800,
                y: 131
            },
            line_9_end: {
                x: 991,
                y: 131
            },
            line_9_gap_0: {
                x: 223,
                y: 146
            },
            line_9_gap_1: {
                x: 397,
                y: 204
            },
            line_9_gap_2: {
                x: 607,
                y: 200
            },
            line_9_gap_3: {
                x: 733,
                y: 155
            }
        },
        trajectory: [
            0,
            1,
            0,
            1,
            0
        ]
    },
    {
        chunks: {
            line_10_begin: {
                x: 31,
                y: 479
            },
            line_10_cell_0: {
                x: 32,
                y: 444
            },
            line_10_cell_1: {
                x: 249,
                y: 310
            },
            line_10_cell_2: {
                x: 436,
                y: 414
            },
            line_10_cell_3: {
                x: 608,
                y: 311
            },
            line_10_cell_4: {
                x: 800,
                y: 435
            },
            line_10_end: {
                x: 991,
                y: 461
            },
            line_10_gap_0: {
                x: 223,
                y: 415
            },
            line_10_gap_1: {
                x: 415,
                y: 385
            },
            line_10_gap_2: {
                x: 583,
                y: 389
            },
            line_10_gap_3: {
                x: 775,
                y: 415
            }
        },
        trajectory: [
            2,
            1,
            2,
            1,
            2
        ]
    },
    {
        chunks: {
            line_11_begin: {
                x: 31,
                y: 160
            },
            line_11_cell_0: {
                x: 32,
                y: 160
            },
            line_11_cell_1: {
                x: 245,
                y: 224
            },
            line_11_cell_2: {
                x: 416,
                y: 242
            },
            line_11_cell_3: {
                x: 608,
                y: 242
            },
            line_11_cell_4: {
                x: 800,
                y: 242
            },
            line_11_end: {
                x: 991,
                y: 242
            },
            line_11_gap_0: {
                x: 223,
                y: 194
            },
            line_11_gap_1: {
                x: 415,
                y: 242
            },
            line_11_gap_2: {
                x: 607,
                y: 242
            },
            line_11_gap_3: {
                x: 799,
                y: 242
            }
        },
        trajectory: [
            0,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_12_begin: {
                x: 31,
                y: 430
            },
            line_12_cell_0: {
                x: 32,
                y: 414
            },
            line_12_cell_1: {
                x: 224,
                y: 338
            },
            line_12_cell_2: {
                x: 416,
                y: 338
            },
            line_12_cell_3: {
                x: 608,
                y: 338
            },
            line_12_cell_4: {
                x: 800,
                y: 338
            },
            line_12_end: {
                x: 991,
                y: 338
            },
            line_12_gap_0: {
                x: 201,
                y: 388
            },
            line_12_gap_1: {
                x: 415,
                y: 338
            },
            line_12_gap_2: {
                x: 607,
                y: 338
            },
            line_12_gap_3: {
                x: 799,
                y: 338
            }
        },
        trajectory: [
            2,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_13_begin: {
                x: 31,
                y: 279
            },
            line_13_cell_0: {
                x: 32,
                y: 279
            },
            line_13_cell_1: {
                x: 224,
                y: 246
            },
            line_13_cell_2: {
                x: 435,
                y: 161
            },
            line_13_cell_3: {
                x: 608,
                y: 161
            },
            line_13_cell_4: {
                x: 800,
                y: 161
            },
            line_13_end: {
                x: 991,
                y: 161
            },
            line_13_gap_0: {
                x: 223,
                y: 279
            },
            line_13_gap_1: {
                x: 415,
                y: 225
            },
            line_13_gap_2: {
                x: 607,
                y: 161
            },
            line_13_gap_3: {
                x: 799,
                y: 161
            }
        },
        trajectory: [
            1,
            1,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_14_begin: {
                x: 31,
                y: 314
            },
            line_14_cell_0: {
                x: 32,
                y: 314
            },
            line_14_cell_1: {
                x: 224,
                y: 314
            },
            line_14_cell_2: {
                x: 477,
                y: 414
            },
            line_14_cell_3: {
                x: 608,
                y: 432
            },
            line_14_cell_4: {
                x: 800,
                y: 432
            },
            line_14_end: {
                x: 991,
                y: 432
            },
            line_14_gap_0: {
                x: 223,
                y: 314
            },
            line_14_gap_1: {
                x: 415,
                y: 345
            },
            line_14_gap_2: {
                x: 607,
                y: 432
            },
            line_14_gap_3: {
                x: 799,
                y: 432
            }
        },
        trajectory: [
            1,
            1,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_15_begin: {
                x: 31,
                y: 262
            },
            line_15_cell_0: {
                x: 32,
                y: 237
            },
            line_15_cell_1: {
                x: 235,
                y: 181
            },
            line_15_cell_2: {
                x: 416,
                y: 181
            },
            line_15_cell_3: {
                x: 608,
                y: 181
            },
            line_15_cell_4: {
                x: 800,
                y: 181
            },
            line_15_end: {
                x: 991,
                y: 181
            },
            line_15_gap_0: {
                x: 223,
                y: 225
            },
            line_15_gap_1: {
                x: 415,
                y: 181
            },
            line_15_gap_2: {
                x: 607,
                y: 181
            },
            line_15_gap_3: {
                x: 799,
                y: 181
            }
        },
        trajectory: [
            1,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_16_begin: {
                x: 31,
                y: 330
            },
            line_16_cell_0: {
                x: 32,
                y: 330
            },
            line_16_cell_1: {
                x: 284,
                y: 414
            },
            line_16_cell_2: {
                x: 416,
                y: 414
            },
            line_16_cell_3: {
                x: 608,
                y: 414
            },
            line_16_cell_4: {
                x: 800,
                y: 414
            },
            line_16_end: {
                x: 991,
                y: 411
            },
            line_16_gap_0: {
                x: 223,
                y: 353
            },
            line_16_gap_1: {
                x: 415,
                y: 411
            },
            line_16_gap_2: {
                x: 607,
                y: 411
            },
            line_16_gap_3: {
                x: 799,
                y: 411
            }
        },
        trajectory: [
            1,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_17_begin: {
                x: 9,
                y: 131
            },
            line_17_cell_0: {
                x: 32,
                y: 131
            },
            line_17_cell_1: {
                x: 224,
                y: 131
            },
            line_17_cell_2: {
                x: 416,
                y: 131
            },
            line_17_cell_3: {
                x: 608,
                y: 131
            },
            line_17_cell_4: {
                x: 800,
                y: 227
            },
            line_17_gap_0: {
                x: 223,
                y: 131
            },
            line_17_gap_1: {
                x: 415,
                y: 131
            },
            line_17_gap_2: {
                x: 607,
                y: 131
            },
            line_17_gap_3: {
                x: 791,
                y: 225
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            1
        ]
    },
    {
        chunks: {
            line_18_begin: {
                x: 9,
                y: 461
            },
            line_18_cell_0: {
                x: 32,
                y: 461
            },
            line_18_cell_1: {
                x: 224,
                y: 461
            },
            line_18_cell_2: {
                x: 416,
                y: 461
            },
            line_18_cell_3: {
                x: 608,
                y: 414
            },
            line_18_cell_4: {
                x: 800,
                y: 314
            },
            line_18_gap_0: {
                x: 223,
                y: 461
            },
            line_18_gap_1: {
                x: 415,
                y: 461
            },
            line_18_gap_2: {
                x: 607,
                y: 461
            },
            line_18_gap_3: {
                x: 743,
                y: 363
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            1
        ]
    },
    {
        chunks: {
            line_19_begin: {
                x: 31,
                y: 453
            },
            line_19_cell_0: {
                x: 32,
                y: 453
            },
            line_19_cell_1: {
                x: 224,
                y: 425
            },
            line_19_cell_2: {
                x: 424,
                y: 325
            },
            line_19_cell_3: {
                x: 608,
                y: 429
            },
            line_19_cell_4: {
                x: 800,
                y: 506
            },
            line_19_end: {
                x: 991,
                y: 506
            },
            line_19_gap_0: {
                x: 223,
                y: 453
            },
            line_19_gap_1: {
                x: 415,
                y: 415
            },
            line_19_gap_2: {
                x: 589,
                y: 415
            },
            line_19_gap_3: {
                x: 799,
                y: 506
            }
        },
        trajectory: [
            2,
            2,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_20_begin: {
                x: 31,
                y: 138
            },
            line_20_cell_0: {
                x: 32,
                y: 138
            },
            line_20_cell_1: {
                x: 224,
                y: 138
            },
            line_20_cell_2: {
                x: 466,
                y: 224
            },
            line_20_cell_3: {
                x: 608,
                y: 86
            },
            line_20_cell_4: {
                x: 800,
                y: 86
            },
            line_20_end: {
                x: 991,
                y: 86
            },
            line_20_gap_0: {
                x: 223,
                y: 138
            },
            line_20_gap_1: {
                x: 415,
                y: 163
            },
            line_20_gap_2: {
                x: 548,
                y: 162
            },
            line_20_gap_3: {
                x: 799,
                y: 86
            }
        },
        trajectory: [
            0,
            0,
            1,
            0,
            0
        ]
    }
]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 29
// module chunks = 0